import { CarePlanPage } from "./carePlan";

export const CarePlan = CarePlanPage;
